export interface NavItem {
  label: string;
  href: string;
  description?: string;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

// Story 15-1: Updated main nav — Bikes, Service, Tax Voucher, About, Contact
export const mainNavItems: NavItem[] = [
  { label: "Bikes",       href: "/bikes" },
  { label: "Service",     href: "/services" },
  { label: "Tax Voucher", href: "/savings#tax-credit" },
  { label: "About",       href: "/about" },
  { label: "Contact",     href: "/contact" },
];

// Story 15-1: Four-column footer sitemap — Bikes, Service, Company, Contact
export const footerNavGroups: NavGroup[] = [
  {
    label: "Bikes",
    items: [
      { label: "All Bikes",        href: "/bikes" },
      { label: "Financing",        href: "/savings#financing" },
      { label: "Trade-In",         href: "/savings#trade-in" },
      { label: "Savings",          href: "/savings" },
      { label: "Tax Voucher",      href: "/savings#tax-credit" },
      // 2026-08-06: Colorado's income-qualified rebate reopened for
      // registration (Aug 24). Distinct from the $225 tax-credit discount.
      { label: "CO Rebate",        href: "/savings#rebate" },
    ],
  },
  {
    label: "Service",
    items: [
      { label: "Services",         href: "/services" },
      { label: "Schedule Maintenance", href: "/services" },
    ],
  },
  {
    label: "Company",
    items: [
      { label: "About",            href: "/about" },
      { label: "Contact",          href: "/contact" },
      { label: "FAQ",              href: "/faq" },
    ],
  },
];

// 2026-08-06: these pointed at "frontrangebikes", which is not the shop's
// handle on any network. Verified by crawling every outbound link:
//   instagram.com/frontrangebikes .... wrong handle
//   facebook.com/frontrangebikes ..... HTTP 400
//   youtube.com/@frontrangebikes ..... HTTP 404 (no such channel)
// The live Shopify production site at frontrangecargobikes.com links to exactly
// two socials, and those are the ones used here. YouTube was dropped — no
// channel exists under any spelling we could find, and a footer icon leading to
// a 404 is worse than no icon.
// TODO(Ryan): confirm these two are the accounts you actually use, and send a
// YouTube URL if a channel exists.
export const socialLinks = [
  { label: "Instagram", href: "https://www.instagram.com/frontrangecargobikes/", icon: "instagram" },
  { label: "Facebook",  href: "https://www.facebook.com/frontrangecargobikes/",  icon: "facebook" },
];

export const contactInfo = {
  address: "2500 47th Street Unit #12 Boulder, CO 80301",
  phone:   "303-263-6549",
  email:   "info@frontrangecargobikes.com",
  hours:   "Tue-Sat: 10am-6pm, Sun-Mon: Closed",
};
